// src/components/TermsModal.js
import React, { useState, useEffect, useRef } from 'react';
import './TermsModal.css';
import termsHtml from './termsHtml'; // ✅ Import your full HTML

export default function TermsModal({ show, onAgree }) {
  const [isChecked, setIsChecked] = useState(false);
  const termsContentRef = useRef(null);

  // Disable background scroll
  
    
  if (!show) return null;

  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal-content">
        <div 
          className="terms-text" 
          ref={termsContentRef}
          dangerouslySetInnerHTML={{ __html: termsHtml }}
        />

        {/* Checkbox always visible at very bottom */}
        <div className="terms-checkbox">
          <input
            type="checkbox"
            id="acceptTerms"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <label htmlFor="acceptTerms">
            I have read and agree to the Terms and Conditions, Privacy Policy, and Cookie Policy.
          </label>
        </div>

        {/* Button below checkbox */}
        <button
          onClick={onAgree}
          disabled={!isChecked}
          style={{
            opacity: isChecked ? 1 : 0.6,
            cursor: isChecked ? 'pointer' : 'not-allowed'
          }}
        >
          I Agree
        </button>
      </div>
    </div>
  );
}
